// extracted by mini-css-extract-plugin
module.exports = {"profileLink":"_2hJG6y","kioskModeWrapper":"_3vD8aL"};